import videojs from 'video.js';

$(document).ready(function() {
    [].forEach.call(document.querySelectorAll('.video-js'), function(video) {
        const videoPlayer = videojs(video.getAttribute('id'));           
        
        videoPlayer.bigPlayButton.hide();

        document.querySelector('.video-player-btn').onclick = function (e) { 
            videoPlayer.play(); 
            this.classList.add('hidden');  
            document.querySelector('.video-player-placeholder').classList.add('hidden');       
        };
    });
});